// Libraries
import { action } from "mobx";

// Custom
import { GutterSystemModel } from "Custom/Models/Domain/ProductSelector/SubModels/GutterSystem";

export class ProductsCommonViewModel {
    private model: GutterSystemModel;

    constructor(model: GutterSystemModel) {
        this.model = model;
    }

    // #region Product Properties

    @action
    public setGutterLengthMeterage = (value: number): void => {
        this.model.DelcoteProducts.DelcoteGSModel.gutterLengthMeterage = value;
        this.model.PlygeneProducts.PlygeneMouldedModel.gutterLengthMeterage = value;
        this.model.PlygeneProducts.PlygeneStandardModel.gutterLengthMeterage = value;
    };

    @action
    public setGirth = (value: number): void => {
        this.model.DelcoteProducts.DelcoteGSModel.girth = value;
        this.model.PlygeneProducts.PlygeneMouldedModel.girth = value;
        this.model.PlygeneProducts.PlygeneStandardModel.girth = value;
    };

    // #region Product Properties
}
